import { useAtomValue, useSetAtom } from 'jotai';
import { useEffect } from 'react';
import { autoScanTriggeredAtom } from '../atoms/session-atoms';
import { useSessionInfoContext } from './use-session-info-context';
export function useAutoScanOnOpen(_ref) {
  let {
    isFirstFetching,
    analyzeFullSite
  } = _ref;
  const {
    shouldAutoScan,
    shouldQueryLatestScan
  } = useSessionInfoContext();
  const autoScanTriggered = useAtomValue(autoScanTriggeredAtom);
  const setAutoScanTriggered = useSetAtom(autoScanTriggeredAtom);
  useEffect(() => {
    if (shouldAutoScan && !shouldQueryLatestScan && !isFirstFetching && !autoScanTriggered) {
      setAutoScanTriggered(true);
      analyzeFullSite();
    }
  }, [isFirstFetching, shouldAutoScan, shouldQueryLatestScan, autoScanTriggered, setAutoScanTriggered, analyzeFullSite]);
}
//# sourceMappingURL=use-auto-scan-on-open.js.map